/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";
var Model = require("../types/Model.js");

// 2 hours
var RECALCULATE_INTERVAL = 2 * 60 * 60 * 1000;

module.exports = new Model({
	name: "trialdata",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_hasTrial: false,
	_hasRefreshed: false,
	_recalculateTimer: null,

	recalculate: recalculate,
	refresh: refresh,
});

function init() {
	this._recalculateTimer = setInterval(this.recalculate.bind(this), RECALCULATE_INTERVAL);

	this.push({
		expired: false
	});
}

function uninit() {
	clearInterval(this._recalculateTimer);
}

function listeners() {
	return {
		"mqtt:$/trial/updated": handleUpdate,
		"mqtt:$/trial/cleared": handleClear,
		"connectivity:online": refresh,
		"personal:updated": handle_personal_update,
	};
}

function handleUpdate(data) {
	this.extend(data);
	this.recalculate();
}

function handleClear() {
	this.extend({
		end: "",
		start: "",
		expired: false,
	});
}

function recalculate() {
	if (!this._hasTrial) return;
	var endDate = this.data.end;
	if (!endDate) {
		if (this.data.expired) this.extend({
			expired: false
		});
		return;
	}
	var endDateTime = (new Date(endDate)).getTime();
	var currentTime = Date.now();

	if (endDateTime < currentTime) {
		if (!this.data.expired) this.extend({
			expired: true
		});
	} else if (this.data.expired) this.extend({
		expired: false
	});
}

function refresh() {
	if (!this._hasTrial) return;
	this.api.trial.data().then(handleUpdate.bind(this));
}

function handle_personal_update(personal) {
	var type = personal.type || [];
	this._hasTrial = type.indexOf("trial") !== -1;
	if(!this._hasTrial) return;
	if (this._hasRefreshed) return;
	this._hasRefreshed = true;
	this.refresh();
}
